// extracted by mini-css-extract-plugin
export default {"galleryContainer":"Galerie_galleryContainer__8lwOD","galleryItem":"Galerie_galleryItem__-bAcJ","galleryImage":"Galerie_galleryImage__GYNMm"};